// extracted by mini-css-extract-plugin
module.exports = {"question":"Accordion_question__7HehB","answer":"Accordion_answer__WLrSL","show":"Accordion_show__qwVs7"};